import MyVesselPdfData from "../../../components/Calculator/MyvesselPdf";
import { downloadPdf, makePdfBlob, sharePdf } from "../../../util/pdfFile";
import { getCurrentUserId } from "../../../utils";
import * as calculatorActions from "../Calculator/actions";
import * as dashboardActions from "../Dashboard/actions";
import { buildVesselPdfData, toPdfVessel } from "../Dashboard/Vessel/steps/editVesselOnFleetAddStep";

// Builds the same PDF as the vessel details modal, for a row of the vessel list. mode: "download" | "share"
export const exportVesselPdf = async (item, mode, onShare = sharePdf) => {
  const res = await calculatorActions.getSingleFleetData(item._id, { userId: getCurrentUserId() });
  const pdfData = buildVesselPdfData(
    toPdfVessel({ ...res.data, vesseldata: JSON.parse(res.data.vessel) })
  );
  const saved = await dashboardActions.addDownloadPdf(pdfData);
  if (!saved?.data?._id) throw new Error("Could not save the vessel PDF");
  const blob = await makePdfBlob(<MyVesselPdfData data={pdfData} pdfId={saved.data._id} />);
  if (mode === "share") await onShare(blob, saved.pdfname);
  else downloadPdf(blob, saved.pdfname);
};
